import React from 'react'
import { Price } from 'lib/shared'
import { MagentoAvailableShippingMethod } from 'lib/types'
import { Container } from './styled'

interface Props {
  method: MagentoAvailableShippingMethod
  onChange: (method: MagentoAvailableShippingMethod) => any
  isSelected: boolean
}

export const ShippingMethodItem = ({ method, onChange, isSelected }: Props) => {
  const {
    amount,
    available,
    carrier_title: carrierTitle,
    method_title: methodTitle
  } = method

  function handleChange () {
    onChange(method)
  }

  if (!available) {
    return null
  }

  return (
    <Container
      onClick={handleChange}
      isSelected={isSelected}
    >
      {methodTitle && (
        <p>
          <strong>{methodTitle}</strong>
        </p>
      )}
      {carrierTitle && (
        <p>
          {carrierTitle}
        </p>
      )}
      <p>
        <Price {...amount} />
      </p>
    </Container>
  )
}
